import { useEffect, useCallback } from 'react';
import useHttp from '../http/useHttp';
import Dropdown from '../../Models/Locations/dropdown';

export default function useFetchFollowUpMethods() {
  const { getDataResponse, getData } = useHttp();

  const init = useCallback(async () => {
    await getData('lookup/getfollowupmethods');
  }, []);

  let followUpMethods: Dropdown[] = getDataResponse?.data ?? [];

  useEffect(() => {
    init();
  }, [init]);

  return { followUpMethods };
}